import { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./RoomInviteModal.module.scss";
import CopyIcon from "../../../components/icons/discount/copy";
import CheckIcon from "../../../components/icons/discount/check";
import CopyToast from "../../../components/shared/CopyToast/CopyToast";
import { copyToClipboard } from "../../../utils/helpers";

interface RoomInviteModalProps {
  roomCode: string;
  isOpen: boolean;
  onClose: () => void;
  onCopy?: () => void;
}

const RoomInviteModal: React.FC<RoomInviteModalProps> = ({
                                                           roomCode,
                                                           isOpen,
                                                           onClose,
                                                           onCopy,
                                                         }) => {
  const { t, i18n } = useTranslation();
  const [toastShown, setToastShown] = useState(false);
  const [copiedOnce, setCopiedOnce] = useState(false);

  const dirData = i18n.language === "ar" ? "rtl" : "ltr";

  if (!isOpen) return null;

  const inviteUrl = `${window.location.origin}/room/${roomCode}`;

  const copyHandler = (e: any) => {
    e.stopPropagation();

    copyToClipboard(inviteUrl);

    if (!copiedOnce) {
      onCopy?.();
      setCopiedOnce(true);
    }

    setToastShown(true);

    setTimeout(() => {
      setToastShown(false);
      onClose();
    }, 2000);
  };

  return (
    <>
      <div className={styles.overlay} onClick={onClose}>
        <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
          <div dir={dirData} className={styles.textBlock}>
            <div className={styles.label}>
              {t("room_copy_invite", "Copy and send to a friend")}
            </div>
            <div className={styles.url}>{inviteUrl}</div>
          </div>
          <div className={styles.copyIconWrapper} onClick={copyHandler}>
            <CopyIcon />
          </div>
        </div>
      </div>
      <CopyToast show={toastShown} text={t("linkCopiedToast")} icon={<CheckIcon />} />
    </>
  );
};

export default RoomInviteModal;
